import React from 'react';
import { createPolymorphicComponent, Avatar as MantineAvatar } from '@mantine/core';
import { ZapIcon } from 'lucide-react';
import { cn } from 'tailwind-variants';

import type { AvatarTypes as Types } from './Avatar.types';

/**
 * Avatar component
 * TODO: replace with custom UiAvatar component
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const Avatar = createPolymorphicComponent<'div', Types.Props>(
	// eslint-disable-next-line react/display-name
	React.forwardRef<HTMLDivElement, Types.Props>((props, ref) => {
		const { avatarFit = 'cover', children, classNames, ...rest } = props;
		return (
			<MantineAvatar
				ref={ref}
				radius="md"
				size="md"
				{...(avatarFit === 'cover' && {
					classNames: {
						...classNames,
						root: cn('!bg-white', classNames?.root),
						image: cn('object-cover', classNames?.image),
					},
				})}
				{...(avatarFit === 'scale-down' && {
					classNames: {
						...classNames,
						root: cn('!bg-white ring-[1px] m-[1px] ring-zinc-100', classNames?.root),
						image: cn('object-scale-down p-[1px]', classNames?.image),
					},
				})}
				{...(rest as any)}
			>
				{children ?? <ZapIcon className="w-3 h-3" />}
			</MantineAvatar>
		);
	}),
);

Avatar.displayName = MantineAvatar.displayName;
export const AvatarGroup = MantineAvatar.Group;
